import { ChangeDetectionStrategy, Component, Inject, InjectionToken, Input } from '@angular/core';
import { IconTypes } from '@shared/v2/models';

export const SVG_SPRITE_URL = new InjectionToken<string>('SvgSpriteUrl');

/**
 * Компонент `SdvorIconComponent` используется для отображения различных иконок в пользовательском интерфейсе.
 * Иконки могут быть использованы для украшения элементов интерфейса, обозначения действий или предоставления
 * визуальных подсказок.
 *
 * ```ts
 * import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
 * ```
 */
@Component({
  standalone: true,
  selector: 'sd-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: SVG_SPRITE_URL, useValue: require('apps/sdvor/src/assets/v2/sprite.svg') }],
})
export class SdvorIconComponent {
  /** Идентификатор иконки */
  @Input() type: IconTypes;

  /** @ignore */
  constructor(@Inject(SVG_SPRITE_URL) public svgSpriteUrl: string) {}
}
